import { render } from "./NotFound.vue?vue&type=template&id=2d7808b6"
const script = {}
script.render = render

export default script